module.exports = __webpack_public_path__ + "img/logo.3735be35.svg";